/** «trendator» + неоновая точка (docs/design/LogoT.dc.html) и плашка ADMIN. */
export function Wordmark({ admin = true }: { admin?: boolean }) {
  return (
    <span className="flex items-center gap-2.5">
      <span className="text-[26px] leading-none font-black tracking-[-0.03em]">
        trendator
        <span className="ml-[3px] inline-block size-[7px] rounded-full bg-accent shadow-[0_0_12px_rgba(45,180,255,0.8)]" />
      </span>
      {admin ? <span className="rounded-md bg-white/6 px-[7px] py-[3px] text-[11px] font-bold tracking-[0.08em] text-muted">ADMIN</span> : null}
    </span>
  );
}
